import { render } from "./TheJ05ChatScreen.vue?vue&type=template&id=2bfce9be&scoped=true&ts=true"
import script from "./TheJ05ChatScreen.vue?vue&type=script&lang=ts"
export * from "./TheJ05ChatScreen.vue?vue&type=script&lang=ts"

import "./TheJ05ChatScreen.vue?vue&type=style&index=0&id=2bfce9be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfce9be"]])

export default __exports__